// extracted by mini-css-extract-plugin
export default {"container":"ReadMoreButton_container__8KBV-","arrow":"ReadMoreButton_arrow__Uz7xQ","arrowHead":"ReadMoreButton_arrowHead__-Rxah"};